import React from "react";
import {ValueValidator} from "../Validator";
import {PromptInputField} from "../../PromptInputField/PromptInputField";
import {OnValidChangeHandler, ValidationComponent, ValidationFieldName} from "./ValidationComponent";
import {RootState} from "../../../../app/store";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined
    fieldName: ValidationFieldName<OBJECT>
    onChange: (value: PROPERTY) => any
    updateValidationStatus: OnValidChangeHandler<OBJECT>
    label: string
    placeholder?: string
    disabled?: boolean
    required?: boolean
    getMessage: (f: string) => string
    maxLength?: number
    onDelete?: () => void
}

export const ValidatedPromptInputField = <PROPERTY, OBJECT>({
                                                          validator,
                                                          selector,
                                                          fieldName,
                                                          onChange,
                                                          updateValidationStatus,
                                                          label,
                                                          placeholder,
                                                          disabled,
                                                          getMessage,
                                                          required = true,
                                                          maxLength = 30,
                                                          onDelete
                                                      }: Props<PROPERTY, OBJECT>) => {
    return <ValidationComponent<PROPERTY, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        disabled={disabled}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <PromptInputField
                value={value as string}
                setValue={(newValue: string) => onChange(newValue as PROPERTY)}
                placeholder={placeholder}
                disabled={disabled}
                errorMessage={getMessage(fieldName as string)}
                maxLength={maxLength}
                onDelete={onDelete}
            />
        }
    />
}
